<script lang="ts">
	//Services
	import { format } from 'svelte-i18n';
	//Helpers
	import { capFirstChar, convert } from '../../helpers/utilities';
	import { get_gen_2_component_channel_structure } from 'src/helpers/interface_helpers';
	//Design system components
	import { Alert, ParameterCard } from '@Shelly/shelly-design-system';
	//Stores
	import { navigateToSetting } from 'src/stores/ui/navigate-to';

	export let device, status;

	let wUnit = 'W',
		vaUnit = 'VA',
		aUnit = 'A',
		vUnit = 'V';

	$: ctNotCalibrated =
		status?.[get_gen_2_component_channel_structure(device)]?.errors?.includes('ct_type_not_set'); //used to block the component parameter cards visualization if CT type is not set. This will trigger alert with navigation to proper settings page
</script>

<!-- <Row> -->
<!-- {#each phases as phase} -->
<!-- {#if phase === indexToAlphabet(device.channel).toLowerCase()} -->
<!-- <Col xs="12"> -->
<!-- <Text styleType="h2" class="mb-s text-capitalize"
			>{$format(`label_phase_${indexToAlphabet(device.channel)}`, {
				default: `phase ${indexToAlphabet(device.channel)}`
			})}</Text
		> -->
{#if !ctNotCalibrated}
	<ParameterCard
		title={convert(status['em1:' + device.channel]?.act_power, wUnit)}
		description={$format('em_power', { default: 'power' })}
		size="s"
		class="mb-s"
	/>

	<ParameterCard
		title={convert(status['em1:' + device.channel]?.aprt_power, vaUnit)}
		description={capFirstChar(
			$format('em_aparent_power', {
				default: 'apparent power',
			}),
		)}
		size="s"
		class="mb-s"
	/>

	{#if typeof status['em1:' + device.channel]?.current !== 'undefined'}
		<ParameterCard
			title={convert(status['em1:' + device.channel].current, aUnit)}
			description={$format('em_current', { default: 'current' })}
			size="s"
			class="mb-s"
		/>
	{/if}

	<ParameterCard
		title={convert(status['em1:' + device.channel]?.voltage, vUnit)}
		description={$format('em_voltage', { default: 'voltage' })}
		size="s"
		class="mb-s"
	/>

	{#if typeof status['em1:' + device.channel]?.pf !== 'undefined'}
		<ParameterCard
			title={status['em1:' + device.channel]?.pf === 0
				? 'N/A'
				: status['em1:' + device.channel]?.pf}
			description={$format('em_power_factor', {
				default: 'power factor',
			})}
			size="s"
			class="mb-s"
		/>
	{/if}
{:else}
	<Alert
		type="warning"
		class="mb-s"
		heading={$format('em_ct_not_set_error_heading', {
			default: 'CT error type not set',
		})}
		message={$format('em_ct_not_set_error_description', {
			default: 'This channel need to have selected CT type in order to show power metering.',
		})}
		isHeadingBold
		cta={{
			title: $format('settings', { default: 'Settings' }),
		}}
		on:cta_click={() => navigateToSetting(device.id, 'settings', 'change_ct_type')}
	/>
{/if}
<!-- </Col> -->
<!-- {/if} -->
<!-- {/each} -->
<!-- </Row> -->
